import { cn } from "@/lib/utils";

/**
 * The homepage section label: sentence case, sans, one violet accent. The
 * story sections use this instead of the mono uppercase SectionLabel, which
 * read as noise on a phone.
 */
export function Kicker({
  children,
  tone = "default",
  className,
}: {
  children: React.ReactNode;
  tone?: "default" | "light";
  className?: string;
}) {
  return (
    <p
      className={cn(
        "text-sm font-semibold md:text-base",
        tone === "light" ? "text-indigo-300" : "text-primary-600",
        className
      )}
    >
      {children}
    </p>
  );
}
